import { CameraDetail } from '@hakimo-ui/hakimo/types';
import { DetailField, DetailSection } from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import { UpdatePasswordFile } from './update-fields/UpdatePasswordFile';
import { UpdateUserId } from './update-fields/UpdateUserId';

interface Props {
  camera: CameraDetail;
}

export function SettingSectionCreds(props: Props) {
  const { camera } = props;
  const [updateUserId, setUpdateUserId] = useState(false);
  const [updatePasswordFile, setUpdatePasswordFile] = useState(false);

  return (
    <>
      <DetailSection title="Credentials">
        <DetailField
          label="User ID"
          value={camera.camUserId}
          onEdit={() => setUpdateUserId(true)}
        />
        <DetailField
          label="Password File Path"
          value={camera.camPasswordFilePath}
          onEdit={() => setUpdatePasswordFile(true)}
        />
      </DetailSection>
      {updateUserId && (
        <UpdateUserId
          cameraId={camera.id}
          userId={camera.camUserId}
          onClose={() => setUpdateUserId(false)}
        />
      )}
      {updatePasswordFile && (
        <UpdatePasswordFile
          cameraId={camera.id}
          passwordFile={camera.camPasswordFilePath}
          onClose={() => setUpdatePasswordFile(false)}
        />
      )}
    </>
  );
}
